<script>
  import Image from '@components/general/image.svelte'
  import Button from '@components/buttons/button.svelte'
  import Tag from '@components/general/tag.svelte'
  import Empty from '@components/general/empty.svelte'
  import { Play, Lock } from 'lucide-svelte'
  import { setParams } from '@lib/utils'
  import { page } from '@inertiajs/svelte'
  
  let { videos = [], hoverEffect = true } = $props()

  let user = $page.props.user
  let locked = (video) => !video.free && (!user.is_admin && !user?.has_active_membership)

  let iconClass = 'absolute left-1/2 top-1/2 z-20 -translate-x-1/2 -translate-y-1/2 rounded-full bg-white p-2 text-gray-500 opacity-0 transition-opacity group-hover:opacity-100'

</script>

<div class="grid gap-10 grid-cols-[repeat(auto-fill,minmax(25rem,1fr))]">
  
  {#each videos as video (video.id)}

    <!-- The video card -->
    <div class="flex flex-col gap-2 group">

      <!-- The thumbnail as a clickable button -->
      <Button
        variant="naked"
        class="relative block w-full overflow-hidden rounded-lg border border-solid border-gray-200/70 bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500/60"
        style="aspect-ratio: 16 / 9;"
        path={`/videos/${video.id}`}
      >
        <!-- The thumbnail -->
        <Image src={video.vimeo_image_url} alt={video.name} loading="lazy" 
          class="absolute inset-0 z-0 h-full w-full rounded-none object-cover {locked(video) ? 'grayscale opacity-50' : ''}" 
          />

        {#if locked(video)}
          <!-- Locked overlay -->
          <span aria-hidden="true" class="pointer-events-none absolute inset-0 z-10 bg-gray-900/5"></span>
          <Lock size={32} class={iconClass} />
        {:else}
          <!-- Subtle hover bg over the image/button area -->
          {#if hoverEffect}
            <span aria-hidden="true" class="pointer-events-none absolute inset-0 z-10 bg-black/0 transition-colors group-hover:bg-primary-100/50"></span>
          {/if}

          <!-- The play icon (hidden by default, shown on hover) -->
          <Play size={40} class={iconClass} />
        {/if}
      </Button>

      <!-- The video name -->
      <h5 class="text-gray-800 font-medium">{video.name}</h5>
      
      <!-- The tags area -->
      <div class="flex flex-wrap gap-1">
        
        {#each video.tags as tag (tag.id)}
          <Tag {tag} onSelect={tag => setParams({ tag: tag.id, page: 1 })} />
        {:else}
          <Tag tag={{ name: "Untagged", color: "gray" }} onSelect={tag => setParams({ tag: "", page: 1 })} />
        {/each}
      </div>

    </div>
  {:else}
    <Empty message="No videos found" />
  {/each}

</div>
